import { useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { toast } from 'react-toastify';
import { getFirestore, collection, addDoc } from "firebase/firestore";
import { app } from "../config/firebaseConfig";
import ReCAPTCHA from "react-google-recaptcha";
import siteConfig from "../config/site.config";

export const Contact = () => {
  const formInitialDetails = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  }
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState('Send');
  const [captchaValue, setCaptchaValue] = useState(null);
  const recaptchaRef = useRef(null);

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value
    })
  }

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
    // if (value) {
    //   toast.success('Captcha verified successfully!', {
    //     position: "bottom-right",
    //     autoClose: 2000,
    //     theme: "dark"
    //   });
    // }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form data first
    if (!formDetails.firstName.trim()) {
      toast.error('Please enter your first name', {
        position: "bottom-right",
        autoClose: 3000,
        theme: "dark"
      });
      return;
    }

    if (!formDetails.lastName.trim()) {
      toast.error('Please enter your last name', {
        position: "bottom-right",
        autoClose: 3000,
        theme: "dark"
      });
      return;
    }

    if (!formDetails.email.trim()) {
      toast.error('Please enter your email address', {
        position: "bottom-right",
        autoClose: 3000,
        theme: "dark"
      });
      return;
    }

    if (!formDetails.message.trim()) {
      toast.error('Please enter your message', {
        position: "bottom-right",
        autoClose: 3000,
        theme: "dark"
      });
      return;
    }
    
    // After form validation, check captcha
    if (!captchaValue) {
      toast.warn('Please verify that you are not a robot', {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        icon: '🤖'
      });
      return;
    }

    setButtonText("Sending...");

    try {
      console.log("Attempting to save to Firebase...");
      
      // Get Firestore instance
      const db = getFirestore(app);
      
      // Get user's IP address
      const ipResponse = await fetch('https://api.ipify.org?format=json');
      const ipData = await ipResponse.json();
      
      // Create contact data object
      const contactData = {
        firstName: formDetails.firstName.trim(),
        lastName: formDetails.lastName.trim(),
        email: formDetails.email.trim(),
        phone: formDetails.phone.trim() || '',
        message: formDetails.message.trim(),
        timestamp: new Date().toISOString(),
        createdAt: new Date(),
        captchaVerified: true,
        ipAddress: ipData.ip
      };

      // Save to Firebase
      await addDoc(collection(db, "contacts"), contactData);
      
      // Clear form and show success message
      setFormDetails(formInitialDetails);
      
      // Reset captcha
      recaptchaRef.current.reset();
      setCaptchaValue(null);
      
      toast.success('Message sent successfully!', {
        position: "bottom-right",
        autoClose: 3000,
        theme: "dark"
      });
    } catch (error) {
      console.error("Error saving to Firebase:", error);
      
      toast.error(`Failed to send message: ${error.message}`, {
        position: "bottom-right",
        autoClose: 5000,
        theme: "dark"
      });
    } finally {
      setButtonText("Send");
    }
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us"/>
              }
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h2>Get In Touch</h2>
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" value={formDetails.firstName} placeholder="First Name" onChange={(e) => onFormUpdate('firstName', e.target.value)} required />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="text" value={formDetails.lastName} placeholder="Last Name" onChange={(e) => onFormUpdate('lastName', e.target.value)} required />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="email" value={formDetails.email} placeholder="Email Address" onChange={(e) => onFormUpdate('email', e.target.value)} required />
                    </Col>
                    <Col size={12} sm={6} className="px-1">
                      <input type="tel" value={formDetails.phone} placeholder="Phone No." onChange={(e) => onFormUpdate('phone', e.target.value)} />
                    </Col>
                    <Col size={12} className="px-1">
                      <textarea 
                        rows="6" 
                        value={formDetails.message} 
                        placeholder="Message (minimum 10 characters)" 
                        onChange={(e) => onFormUpdate('message', e.target.value)} 
                        minLength="10"
                        required
                      ></textarea>
                      <div className="recaptcha-container">
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey={siteConfig.recaptchaSiteKey}
                          onChange={handleCaptchaChange}
                          theme="light"
                        />
                      </div>
                      <button type="submit"><span>{buttonText}</span></button>
                    </Col>
                  </Row>
                </form>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
